import { useCoreConfigProvider } from './useCoreConfigProvider';
export const useGetImages = () => {
    const { hosts } = useCoreConfigProvider();
    const { assets } = hosts;
    return {
        addAuthorizedUser: `${assets}assets/account-services/manage_cardholders.svg`,
        ladySuccess: `${assets}assets/account-services/lady_success.svg`,
        ladyWarning: `${assets}assets/account-services/lady_warning.svg`,
        requestInProgress: `${assets}assets/account-services/request_in_progress.svg`,
        spotCardSecurity: `${assets}assets/account-services/spot_card_security.svg`,
        technicalErrorCat: `${assets}assets/account-services/technical_error_cat.svg`
    };
};
